import { tv } from '@/utils/styles';

export interface InfoItemProps {
  icon?: React.ComponentType<{ className?: string }>;
  customIcon?: React.ReactElement;
  heading: string;
  detail: string | undefined;
  subHeading?: string;
  subDetail?: string;
  children?: React.ReactNode;
}

const InfoItem = ({ icon: Icon, customIcon, heading, detail, subHeading, subDetail, children }: InfoItemProps) => {
  const { listItem, item, inner, headingStyles, detailStyles, iconStyles } = styles();

  return (
    <li className={listItem()}>
      <div className={item()}>
        {customIcon || (Icon && <Icon className={iconStyles()} />)}
        <div className={inner()}>
          <div>
            <h3 className={headingStyles()}>{heading}</h3>
            <p className={detailStyles()}>{detail}</p>
          </div>
          {subHeading && (
            <div>
              <h4 className={headingStyles()}>{subHeading}</h4>
              <p className={detailStyles()}>{subDetail}</p>
            </div>
          )}
          {children}
        </div>
      </div>
    </li>
  );
};

const styles = tv({
  slots: {
    base: 'rounded border border-grey-300 bg-white p-4 @container/vessel-summary',
    list: 'grid divide-y divide-dashed divide-grey-300',
    listItem: 'grid grid-cols-1 gap-y-2 py-4 first:pt-0 last:pb-0 [&_p]:mb-0',
    item: 'flex items-start gap-x-2 leading-4',
    inner: 'grid w-full gap-y-2 @xs/vessel-summary:grid-cols-2 @xs/vessel-summary:gap-x-2 @xs/vessel-summary:gap-y-0',
    headingStyles: 'm-0 text-sm font-normal text-text-secondary',
    detailStyles: 'm-0 text-baseSm font-semibold text-text-primary',
    iconStyles: 'flex !size-9 items-center justify-center rounded-full border border-grey-300 p-1.5 text-lightBlue-600',
  },
});

export { InfoItem };
